// extracted by mini-css-extract-plugin
export default {"root":"ikQM4Uu","root_removed":"Atg7XH+","num":"vEdx0Y7"};